module.exports = __webpack_public_path__ + "img/trans-exterior-scan.c109e1a0.svg";